import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import AstrotalLkogo from "../../image/astrotalk-logo.png";
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import { useTranslation } from 'react-i18next';
const AstrologerAi = () => {

  const { t } = useTranslation();
  const { setIsToast, setToastMsg, HandleCallApi } = useContext(MyContext);

  const [inputmsg, setInputMsg] = useState("");
  const [allChat, setAllChat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModel, setShowModel] = useState("");
  const [isPlanExpired, setIsPlanExpired] = useState(false);

  const chatBoxBodyRef = useRef(null);
  const ChatLoad = useRef(false);

  const navigate = useNavigate();

  useEffect(() => {
    const AiAllChat = secureLocalStorage.getItem("Aichat");
    if (AiAllChat && AiAllChat !== "null" && AiAllChat !== "undefined") {
      try {
        const parsedChat = typeof AiAllChat === 'string' ? JSON.parse(AiAllChat) : AiAllChat;
        if (parsedChat && Array.isArray(parsedChat)) {
          setAllChat(parsedChat);
          // Auto-lock the chat on load if history contains an out-of-tokens warning
          const hasExpiredMsg = parsedChat.some((chat) => 
            chat.status === "2" && 
            (chat.message?.includes("expired or has 0 tokens") || chat.message?.includes("renew or purchase a plan"))
          );
          if (hasExpiredMsg) {
            setIsPlanExpired(true);
          }
        }
      } catch (e) {
        console.error("Error parsing Aichat in AstrologerAi:", e);
      }
    }
  }, []);

  useEffect(() => {
    if (chatBoxBodyRef.current) {
      chatBoxBodyRef.current.scrollTop = chatBoxBodyRef.current.scrollHeight;
    }

    if (ChatLoad.current) {
      secureLocalStorage.setItem("Aichat", JSON.stringify(allChat));
    }

  }, [allChat]);

  const handleSendMessage = async () => {

    if (!inputmsg) {
      setIsToast(true);
      setToastMsg("Write message !!");
      return;
    }

    const LoginData = secureLocalStorage.getItem("Logindata");
    let birthDate = "";
    let birthTime = "";
    let birthPlace = "";

    if (LoginData && LoginData !== "null" && LoginData !== "undefined") {
      try {
        const ConvertJson = typeof LoginData === 'string' ? JSON.parse(LoginData) : LoginData;
        if (ConvertJson) {
          birthDate = ConvertJson.birth_date || "";
          birthTime = ConvertJson.birth_time || "";
          birthPlace = ConvertJson.birth_place || "";
        }
      } catch (e) {
        console.error("Error parsing Logindata in AstrologerAi sendMessage:", e);
      }
    }

    const ApiData = {
      question: inputmsg,
      birthDate,
      birthTime,
      birthPlace
    }

    handleUserAddChat();
    setLoading(true);

    try {
      const Response = await HandleCallApi("Post", "user/astrology_chat", ApiData);
      const now = new Date();
      const timeString = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const answer = Response?.data?.answer || "Sorry, an unexpected error occurred. Please try again.";
      const isExpired = answer.includes("expired or has 0 tokens") || answer.includes("renew or purchase a plan");

      if (isExpired) {
        setIsPlanExpired(true);
      }

      setAllChat((prev) => {
        const CopyData = [...prev];
        const Chat = {
          date: timeString,
          message: answer,
          status: "2",
        };
        return [...CopyData, Chat];
      });
      ChatLoad.current = true;
    } catch (err) {
      console.error("Error sending AI chat message:", err);
      const now = new Date();
      const timeString = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      setAllChat((prev) => {
        const CopyData = [...prev];
        const Chat = {
          date: timeString,
          message: "Error: Failed to get response from server. Please try again.",
          status: "2",
        };
        return [...CopyData, Chat];
      });
    } finally {
      setLoading(false);
    }
  }

  const handleUserAddChat = () => {
    const now = new Date();

    const timeString = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    setAllChat((prev) => {
      const CopyData = [...prev];

      const Chat = {
        date: timeString,
        message: inputmsg,
        status: "1",
      };

      return [...CopyData, Chat];
    });

    setInputMsg("");
  };

  const handleKeyDown = (e) => {
    if (e.key == "Enter") {
      handleSendMessage();
    }
  }

  const handleClearAllChat = () => {
    setAllChat([]);
    secureLocalStorage.removeItem("Aichat");
    setShowModel("");
    setIsPlanExpired(false); // Reset input lock when chat history is cleared
  }

  return (
    <div className='chat_page'>
      <div className="width_cintainer">
        <div className="chat_box">

          {/* Header */}
          <div className="w-full bg-white px-5 py-4 border border-slate-100 rounded-[16px] flex items-center justify-between shadow-sm sticky top-0 z-10">
            <div className="flex items-center gap-4">
              <button 
                onClick={() => navigate(-1)} 
                className="text-slate-400 hover:text-slate-800 hover:bg-slate-50 p-2 rounded-full transition-all duration-200"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
              </button>
              
              <div className="relative">
                <img src={AstrotalLkogo} className="w-[42px] h-[42px] rounded-full object-cover border border-slate-100 shadow-sm" alt="AI Avatar" />
                <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></span>
              </div>
              
              <div className='text-start'>
                <h1 className="font-bold text-[17px] text-slate-800 leading-tight">{t("Astrologer AI Assistant")}</h1>
                <p className="text-[11px] text-slate-400 font-medium mt-0.5">{t("Always Active")}</p>
              </div>
            </div>
            
            {allChat.length >= 1 && (
              <button 
                onClick={() => setShowModel("Delete")} 
                className="text-slate-400 hover:text-red-500 hover:bg-red-50 p-2.5 rounded-full transition-all duration-200"
                title={t("Clear Chat")}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
              </button>
            )}
          </div>

          {/* Chat area */}
          <div ref={chatBoxBodyRef} className="h-full my-[12px] bg-slate-50/30 rounded-[16px] p-5 border border-slate-100 overflow-y-auto scroll_container">
            {allChat.length >= 1
              ? <div className="flex flex-col flex-grow-1">
                {allChat?.map((item, index) => {
                  return (
                    <div key={index} className={`flex w-full mb-4 ${item.status == 1 ? "justify-end" : "justify-start"}`}>
                      <div 
                        className={`max-w-[70%] rounded-2xl p-4 shadow-sm transition-all text-start flex flex-col ${
                          item.status == 1 
                            ? "bg-gradient-to-r from-orange-500 to-[#FA6400] text-white rounded-tr-none" 
                            : "bg-white border border-slate-100 text-slate-800 rounded-tl-none"
                        }`}
                      >
                        <p className='font-medium text-[15px] whitespace-pre-line leading-relaxed'>
                          {item.message}
                        </p>
                        <span className={`text-[10px] mt-1.5 self-end ${item.status == 1 ? "text-white/80" : "text-slate-400"}`}>
                          {item.date}
                        </span>
                      </div>
                    </div>
                  );
                })}
                {loading && (
                  <div className="flex w-full mb-4 justify-start">
                    <div className="max-w-[70%] rounded-2xl rounded-tl-none p-4 bg-white border border-slate-100 text-slate-800 shadow-sm flex items-center">
                      <div className="flex items-center gap-1.5 py-1 px-1">
                        <div className="w-2.5 h-2.5 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                        <div className="w-2.5 h-2.5 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                        <div className="w-2.5 h-2.5 bg-slate-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                      </div>
                    </div>
                  </div>
                )}
              </div> 
              : <div className="h-full flex flex-col items-center justify-center p-8 text-center max-w-[500px] mx-auto space-y-6">
                  <div className="w-16 h-16 bg-orange-50 rounded-2xl flex items-center justify-center text-[#FA6400] shadow-sm shadow-orange-100 border border-orange-100 animate-pulse">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .6 2.2 1.5 3.1.7.7 1.3 1.5 1.5 2.4" />
                      <path d="M9 18h6" />
                      <path d="M10 22h4" />
                    </svg>
                  </div>
                  <div>
                    <h2 className="font-bold text-[22px] text-slate-800 leading-tight">{t("Astrologer AI Assistant")}</h2>
                    <p className="text-[14px] text-slate-500 mt-2">
                      {t("Ask anything about your zodiac sign, planetary houses, relationships, lucky stars, or general horoscope guidance.")}
                    </p>
                  </div>
                  
                  <div className="w-full flex flex-col gap-2 pt-2">
                    <button 
                      onClick={() => setInputMsg(t("What do my planetary alignments say about my career?"))}
                      className="text-left text-[13px] text-slate-600 hover:text-[#FA6400] hover:bg-orange-50/50 hover:border-orange-200 bg-white border border-slate-100 p-3 rounded-xl transition-all duration-200"
                    >
                      💡 {t("What do my planetary alignments say about my career?")}
                    </button>
                    <button 
                      onClick={() => setInputMsg(t("Analyze my love compatibility and relationship outlook."))}
                      className="text-left text-[13px] text-slate-600 hover:text-[#FA6400] hover:bg-orange-50/50 hover:border-orange-200 bg-white border border-slate-100 p-3 rounded-xl transition-all duration-200"
                    >
                      ❤️ {t("Analyze my love compatibility and relationship outlook.")}
                    </button>
                    <button 
                      onClick={() => setInputMsg(t("What are my lucky gemstones and colors?"))}
                      className="text-left text-[13px] text-slate-600 hover:text-[#FA6400] hover:bg-orange-50/50 hover:border-orange-200 bg-white border border-slate-100 p-3 rounded-xl transition-all duration-200"
                    >
                      💎 {t("What are my lucky gemstones and colors?")}
                    </button>
                  </div>
                </div>
            }
          </div>

          {/* Plan Expired Warning Banner */}
          {isPlanExpired && (
            <div className="w-full bg-amber-50 border border-amber-200 rounded-[16px] p-4 mb-3 flex items-center justify-between gap-3 text-amber-800 text-[13px] animate-fade-in text-start">
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-amber-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                <span className="font-semibold">{t("Your active AI plan has expired or has 0 tokens remaining.")}</span>
              </div>
              <button 
                onClick={() => navigate("/dashboard")} 
                className="bg-amber-600 hover:bg-amber-700 text-white font-bold px-3.5 py-1.5 rounded-[10px] transition-colors text-[12px] flex-shrink-0"
              >
                {t("Upgrade")}
              </button>
            </div>
          )}

          {/* Input Bar */}
          <div className="w-full bg-white px-5 py-4 border border-slate-100 rounded-[16px] shadow-sm">
            <div className="flex items-center gap-3">
              <input 
                type="text" 
                value={inputmsg} 
                disabled={isPlanExpired}
                onKeyDown={handleKeyDown} 
                onChange={(e) => setInputMsg(e.target.value)} 
                className={`w-full focus-within:border-[#FA6400] border border-slate-200 outline-none rounded-[12px] px-4 py-3 text-[14px] transition-all ${isPlanExpired ? "bg-slate-50 cursor-not-allowed text-slate-400 border-slate-200" : "hover:border-slate-300"}`} 
                placeholder={isPlanExpired ? t("Chat disabled: Plan expired or out of tokens.") : t("Write message to assistant...")} 
              />
              <button 
                disabled={isPlanExpired}
                onClick={handleSendMessage} 
                className={`p-3.5 rounded-[12px] transition duration-200 flex items-center justify-center ${isPlanExpired ? "bg-slate-100 cursor-not-allowed text-slate-400" : "bg-[--bgcolor] hover:bg-orange-600 hover:scale-[1.03] active:scale-[0.97] text-white shadow-md shadow-orange-100"}`}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <line x1="22" y1="2" x2="11" y2="13"></line>
                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                </svg>
              </button>
            </div>
          </div>

        </div>
      </div>

      {/* Delete Chat Confirmation Modal */}
      {showModel === "Delete" && <div className="model items-center justify-center z-[9999]">
        {/* Backdrop click to dismiss */}
        <div className="fixed inset-0 bg-black/40 backdrop-blur-[3px] transition-opacity duration-300" onClick={() => setShowModel("")}></div>
        
        {/* Modal Card */}
        <div className="relative w-[360px] max-w-[calc(100%-32px)] bg-white p-6 rounded-[20px] shadow-2xl border border-slate-100 z-10 modal-scale-in text-start">
          <h2 className="text-[20px] font-bold text-slate-800 leading-tight mb-2">{t("Clear Chat?")}</h2>
          <p className="text-[14px] text-slate-500">{t("All messages will be deleted permanently.")}</p>

          <div className="flex items-center justify-end gap-3 mt-6">
            <button 
              onClick={() => setShowModel("")} 
              className="px-4 py-2 border border-slate-200 rounded-[10px] font-semibold text-slate-600 text-[14px] hover:bg-slate-50 transition-colors"
            >
              {t("Cancel")}
            </button>
            <button 
              onClick={handleClearAllChat} 
              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-[10px] font-semibold text-[14px] shadow-md shadow-red-100 transition-colors"
            >
              {t("Clear")}
            </button>
          </div>
        </div>
      </div>}

    </div>
  )
}

export default AstrologerAi